import { useEffect, useState } from 'react';

interface ExpiryTimerProps {
  expiresAt: number;
}

export default function ExpiryTimer({ expiresAt }: ExpiryTimerProps) {
  const [timeLeft, setTimeLeft] = useState<string>('');

  useEffect(() => {
    function updateTimer() {
      const now = Date.now();
      const diff = expiresAt - now;

      if (diff <= 0) {
        setTimeLeft('Expired');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
      } else if (minutes > 0) {
        setTimeLeft(`${minutes}m ${seconds}s`);
      } else {
        setTimeLeft(`${seconds}s`);
      }
    }

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  const isExpired = timeLeft === 'Expired';

  return (
    <div className="text-center">
      <p className="text-gray-400 text-sm">
        {isExpired ? 'This location has' : 'Expires in'}
      </p>
      <p className={`text-xl font-bold ${isExpired ? 'text-wobisch-red' : 'text-white'}`}>
        {timeLeft}
      </p>
    </div>
  );
}
